<template>
  <div id="topProducts">

    <div class="twoflow">
      <h1 v-if="arrs1.length > 0">{{arrs1[0]['name']}}</h1>

      <div class="swipertop">
        <div id="flows1" class="flows" :style="{width: flowsWidth + 'px'}">
          <div class="img-card" :class="{focus: activeIndex === 't' + index}" v-for="(item ,index) in arrs1" :key="'t' + index" @mouseenter="mouseEnterHandle($event, 't' + index)" @mouseleave="mouseLeaveHandle">
            <div class="cover" :class="{'coverleft':activeIndex === 't' + index && divshow=='left','coverright':activeIndex === 't' + index && divshow=='right' }" ></div>
            <img v-if="!item.videoSrc" :src="item.imgurl" :alt="item.title">
            <img v-else :src="item.videoCoverImgUrl" :alt="item.title" @click="showVideo(item.videoSrc)">
            <!--<p>{{'t' + index}}</p>-->
            <div class="info" :class="[divshow, {show: activeIndex === 't' + index}]">
              <p class="name"><span>{{item.title}}</span> <a @click="mai(item.url)">购买</a> </p>
              <span class="des">
                  {{item.desc}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="swiperbottom">
        <div id="flows2" class="flows" :style="{width: flowsWidth + 'px'}">
          <div class="img-card" :class="[{focus: activeIndex === 'b' + index}]" v-for="(item ,index) in arrs1" :key="'b' + index" @mouseenter="mouseEnterHandle($event, 'b' + index)" @mouseleave="mouseLeaveHandle">
            <div class="cover" :class="{'coverleft':activeIndex === 'b' + index && divshow=='left','coverright':activeIndex === 'b' + index && divshow=='right' }" ></div>
            <!--<img :src="item.imgurl" alt="">-->
            <img v-if="!item.videoSrc" :src="item.imgurl" :alt="item.title">
            <img v-else :src="item.videoCoverImgUrl" :alt="item.title" @click="showVideo(item.videoSrc)">
            <!--<p>{{'b' + index}}</p>-->
            <div class="info" :class="[divshow, {show: activeIndex === 'b' + index}]">
              <p class="name"><span>{{item.title}}</span> <a @click="mai(item.url)">购买</a> </p>
              <div class="des">
                <p>{{item.desc}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import img from '../../assets/img/temp/c.png'
export default {
  name: 'topProducts',
  props: {
      pluginJson: {
          type: Array
      },
      // pluginIndex: {
      //     type: String
      // }
  },
  data () {
    return {
      activeIndex: null,
      divshow: null,
      noswingtop: false,
      noswingbottom: false,
      arrs: [
        {
          name: '代表产品',
          description: '产品名称0#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称1#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称2#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称3#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称4#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称5#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称6#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }, {
          name: '代表产品',
          description: '产品名称7#蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。#xxxxxxxxxxxxmaii',
          thumbnail: img,
          video: {
            videoCoverImgUrl: '',
            videoIntro: ''
          },
          title: '产品名称0',
          url: 'xxxxxxxxxxxxmaii',
          desc: '蔬菜是指可以做菜、烹饪成为食品的一类植物或菌类，蔬菜是人们日常饮食中必不可少的食物之一。'
        }
      ],
      arrs1: [],
      arrs2: [],
      currindex: 0,
      c: 0,
      documentWidth: 0,
      flowsWidth: 0,
      cardsWidth: 0
    }
  },
  filters: {
    lengthfunc (arr) {
      if (arr.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
  },
  mounted () {

    console.log('watch pluginJson', this.pluginJson)
    console.log('this.pluginJson', this.pluginJson)

    let _this = this
    let length = this.pluginJson.length
    for (let i = 0; i < length; i++) {
      let material = this.pluginJson[i]
      let obj = {}
      obj['name'] = material['name']
      obj['description'] = material['description']
      obj['title'] = material['description'].split('#')[0]
      obj['desc'] = material['description'].split('#')[1]
      obj['url'] = material['description'].split('#')[2]
      obj['imgurl'] = material['thumbnail']
      obj['videoCoverImgUrl'] = material['video']['videoCoverImgUrl'] // 视频表面
      obj['videoSrc'] = material['video']['videoIntro'] // 视频url

      if (i < parseInt(length / 2)) {
        this.arrs1.push(obj)
      } else {
        this.arrs2.push(obj)
      }
    }


    //复制一份数据加在数据后面 两份数据 当移动到一一半位置时
    // 复制一次自己
    this.arrs1 = this.arrs1.concat(this.arrs1)
    this.documentWidth = document.documentElement.clientWidth
    this.cardsWidth = this.documentWidth / 4
    this.$nextTick(() => {
      // setTimeout

      console.log('clientHeight',document.getElementsByClassName('img-card')[0].clientWidth)
      this.flowsWidth = this.arrs1.length * document.getElementsByClassName('img-card')[0].clientWidth
    })
    // this.flowsWidth = this.arrs1.length * document.getElementsByClassName('img-card')[0].clientWidth
    // let moveLeft = document.documentElement.clientWidth - this.flowsWidth
  },
  watch: {
    pluginJson: {
      handler (newvalue, oldvalue) {

      },
      deep: true
    }
  },
  // 计算属性，获得可以操作的swiper对象
  methods: {
    mouseEnterHandle (event, index) {
      console.log(index)
      if (event.clientX * 2 < this.documentWidth) {
        // 右边
        // console.log('右边')
        this.divshow = 'right'
      }
      if (event.clientX * 2 >= this.documentWidth) {
        // 左边
        // console.log('左边')
        this.divshow = 'left'
      }
      this.activeIndex = index
      if (index.startsWith('t')) {
        document.getElementById('flows1').style.animationPlayState = 'paused'
      } else if (index.startsWith('b')) {
        document.getElementById('flows2').style.animationPlayState = 'paused'
      }
    },
    mouseLeaveHandle () {
      this.activeIndex = null
      this.divshow = null
      document.getElementById('flows1').style.animationPlayState = 'running'
      document.getElementById('flows2').style.animationPlayState = 'running'
    },
    showVideo (videoSrc) {
      // console.log(videoSrc)
      this.$emit('showMedia', { 'url': videoSrc, 'type': 'video' })
    },
    shouqi (index) {
      this.divshow = false
    },
    swiperclick (index) {
      console.log('swiperclick', index)
    },
    mai (url) {
      console.log('跳转链接', url)
      window.open(url,'_blank')
    },
    enterfunc (e, index) { // index t1
      console.log(window.swipertop)
      if (index.indexOf('t') > -1) {
        window.swipertop.autoplay.stop()
        this.noswingtop = true
      }
      if (index.indexOf('b') > -1) {
        window.swiperbottom.autoplay.stop()
        this.noswingbottom = true
      }

      let width = document.body.clientWidth
      if (e.clientX * 2 < width) {
        // 右边
        console.log('右边')
        this.divshow = 'r-' + index
      }
      if (e.clientX * 2 >= width) {
        // 左边
        console.log('左边')
        this.divshow = 'l-' + index
      }
    },
    leavefunc (index) {
      console.log('leavefunc', index)
      if (index.indexOf('t') > -1) {
        console.log('ttttttt', index)
        window.swipertop.autoplay.start()
        this.noswingtop = false
      }
      if (index.indexOf('b') > -1) {
        console.log('bbbbbbbbbbb', index)
        window.swiperbottom.autoplay.start()
        this.noswingbottom = false
      }
      this.divshow = false
    },
    changeIndex (index) {
      if (this.activeIndex !== index) {
        this.activeIndex = index
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @function rem($px) {
    @return $px * (1/40) * 1rem;
  }

  #topProducts{
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    padding-top: rem(84);
    position: relative;
    #flow2{
      margin-top: rem(52);
    }
    .zhezhao1{
      width: rem(95);
      height: rem(526);
      position: absolute;
      top: rem(84);
      left: 0;
      background: linear-gradient(360deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
      filter: blur(0px);
    }
    .zhezhao2{
      width: rem(95);
      height: rem(526);
      position: absolute;
      top: rem(84);
      right: 0;
      background: linear-gradient(360deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
      filter: blur(0px);
    }
    .twoflow{
      background-color: #EBEBEB;
      padding-top: rem(57);
      padding-bottom: rem(179);
      overflow: visible;
      box-shadow: inset 0px 0px 42px 0px rgba(0, 0, 0, 0.32);
      h1{
        width: 100%;
        text-align: center;
        font-size: rem(36);
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        /*color: #008C8C;*/
        color: var(--body-color);
        line-height: rem(50);
        margin-bottom: rem(90);
      }
    }
    .swipertop{
      width: 100%;
      height: rem(180);
      overflow: hidden;
      margin-bottom: rem(90);
    }
    .swiperbottom{
      width: 100%;
      height: rem(180);
      overflow: hidden;
      .flows{
        animation: flowsMoveReverse 20s linear infinite;
      }
      /*margin-bottom: 90px;*/
    }
    .flows {
      display: flex;
      align-items: center;
      /*transition: all 10s;*/
      /*transform: translateX(0);*/
      animation: flowsMove 20s linear infinite;

      .img-card{
        width: rem(320);
        /*flex-grow: 1;*/
        height: rem(180);
        padding: 0 rem(40);
        /*border-radius: rem(35);*/
        /*border-top-right-radius: rem(0) !important;*/
        /*border-bottom-right-radius: rem(0) !important;*/
        /*box-sizing: border-box;*/
        position: relative;
        z-index: 1;
        &.focus{
          z-index: 3;

        }
        .cover{
          position: absolute;
          width: rem(320);
          /*width: 100%;*/
          height: rem(180);
          border-radius: rem(35);
          z-index: 1;
          top: 0;
          background-color: #FFFFFF;
        }
        .coverleft{
          border-top-left-radius: rem(0) ;
          border-bottom-left-radius: rem(0) ;
        }
        .coverright{
          border-top-right-radius: rem(0) ;
          border-bottom-right-radius: rem(0) ;
        }
        img{
          width: rem(320);
          /*width: 100%;*/
          height: rem(180);
          border-radius: rem(35);
          position: relative;
          z-index: 2;
        }
        .info{
          width: rem(360);
          height: rem(180);
          background: #ffffff;
          border-radius: rem(35);
          display: none;
          position: absolute;
          z-index: 1;
          padding: 0 rem(20);
          &.left{
            left: rem(-360);
            top: 0;
            border-top-right-radius: rem(0);
            border-bottom-right-radius: rem(0);
            animation: infoleft 1s ease-in-out ;
          }
          &.right{
            right: rem(-360);
            top: 0;
            border-top-left-radius: rem(0);
            border-bottom-left-radius: rem(0);
            animation: inforight 1s ease-in-out ;

          }
          &.show{
            display: block;
          }
          .name{
            height: rem(33);
            margin-top: rem(25);
            font-size: rem(18);
            /*color: #008C8C;*/
            color: var(--body-color);
            display: block;
            width: 100%;
            span{
              float: left;
            }
            a{
              display: inline-block;
              float: right !important;
              right: rem(20);
              font-size: rem(14) !important;
              text-decoration: underline;
              cursor: pointer;
              /*color: #008C8C;*/
              color: var(--body-color);
            }
          }
          .des{
            display: block;
            margin-top: rem(22);
            font-size: rem(12);
            text-align: left;
            /*color: #008C8C;*/
            color: var(--body-color);
            width: rem(279);
            height: rem(90);
            overflow-y: scroll;
            text-align: left;
            p{

            }
          }
        }
      }
    }
    .swiperslidehoverr{
      border-top-right-radius: rem(0);
      border-bottom-right-radius: rem(0);
    }
    .swiperslidehoverl{
      border-top-left-radius: rem(0);
      border-bottom-left-radius: rem(0);
    }
  }
  @keyframes infoleft {
    0% {
      left: rem(-100);
    }
    100% {
      left: rem(-360);
    }
  }
  @keyframes inforight {
    0% {
      right: rem(-100);
    }
    100% {
      right: rem(-360);
    }
  }

  @keyframes flowsMove {
    0% {transform: translateX(0%)}
    100% {transform: translateX(-50%)}
  }

  @keyframes flowsMoveReverse {
    0% {transform: translateX(-50%)}
    100% {transform: translateX(0%)}
  }
</style>
